import React from 'react';

const Section6 = ({ mode, collapsedSections, renderSectionHeader, dsoData, sectionNote }) => {
  // Calculate TAT data from dsoData
  const tatData = [
    {
      title: 'Under Consideration to Booking',
      days: Math.round(dsoData?.data?.ucToBookingConversion?.current || 0)
    },
    {
      title: 'Deal Approval to Agreement Upload',
      days: Math.round(dsoData?.data?.agreementDays || 0)
    },
    {
      title: 'Home Loan Conversion',
      days: Math.round(dsoData?.data?.loanDays || 0)
    },
    {
      title: 'Escalation Closure',
      days: Math.round(dsoData?.data?.escalationClosure?.current || 0)
    },
    {
      title: 'Booking to Approval',
      days: Math.round(dsoData?.data?.bookingTime || 0)
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      {renderSectionHeader(6, 'Turnaround Time (TAT)')}
      {(mode === 'view' || !collapsedSections[6]) && (
        <div className="space-y-4">
          {/* First row: 3 cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {tatData.slice(0, 3).map((item, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-6 bg-gray-50">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="font-semibold text-gray-900">{item.title || 'N/A'}</h3>
                </div>
                <div className="flex items-center gap-2">
                  <p className="text-4xl font-bold text-blue-600">{item.days || 0}</p>
                  <p className="text-sm text-gray-600 mt-1">days average</p>
                </div>
              </div>
            ))}
          </div>
          {/* Second row: 2 cards taking full width */}
          {tatData.length > 3 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {tatData.slice(3).map((item, index) => (
                <div key={index + 3} className="border border-gray-200 rounded-lg p-6 bg-gray-50">
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="font-semibold text-gray-900">{item.title || 'N/A'}</h3>
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="text-4xl font-bold text-blue-600">{item.days || 0}</p>
                    <p className="text-sm text-gray-600 mt-1">days average</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {/* Section Note */}
      {sectionNote && (
        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-start gap-2">
            <svg
              className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h4 className="text-sm font-semibold text-gray-900">
                  {sectionNote.user?.vertical || 'Management'} notes
                </h4>
                <div className="inline-flex items-center gap-1 px-2 py-0.5 bg-gray-100 rounded-full">
                  <span className="text-xs text-gray-600">By</span>
                  <span className="text-xs font-medium text-gray-900">
                    {sectionNote.user?.name || 'Unknown User'}
                  </span>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{sectionNote.note}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Section6;
